function adjustNapoleonFavicons() {
    if (window.location.hostname.includes('napoleoncasino.be') || window.location.hostname.includes('napoleondice.be')) {
        const defaultFavicon = document.querySelector('#defaultFavicon');
        defaultFavicon?.setAttribute('href', '/static/img/icons/favicon-napoleon-casino.ico');

        const favicon16 = document.querySelector('#favicon16');
        favicon16?.setAttribute('href', '/static/img/icons/favicon-napoleon-casino-16x16.png');

        const favicon32 = document.querySelector('#favicon32');
        favicon32?.setAttribute('href', '/static/img/icons/favicon-napoleon-casino-32x32.png');

        const faviconSvg = document.querySelector('#faviconSvg');
        faviconSvg?.setAttribute('href', '/static/img/icons/favicon-napoleon-casino.svg');

        const safariPinnedTab = document.querySelector('#safariPinnedTab');
        safariPinnedTab?.setAttribute('href', '/static/img/icons/favicon-napoleon-casino.svg');

        const appleTouchIcon = document.querySelector('#appleTouchIcon');
        appleTouchIcon?.setAttribute('href', '/static/img/icons/apple-touch-icon-napoleon-casino.png');

        const manifest = document.querySelector('#manifest');
        manifest?.setAttribute('href', '/static/manifest-napoleon-casino.json');
    }

    if (window.location.hostname.includes('napoleonsports.be') || window.location.hostname.includes('napoleongames.be')) {
        const defaultFavicon = document.querySelector('#defaultFavicon');
        defaultFavicon?.setAttribute('href', '/static/img/icons/favicon-napoleon-sport.ico');

        const favicon16 = document.querySelector('#favicon16');
        favicon16?.setAttribute('href', '/static/img/icons/favicon-napoleon-sport-16x16.png');

        const favicon32 = document.querySelector('#favicon32');
        favicon32?.setAttribute('href', '/static/img/icons/favicon-napoleon-sport-32x32.png');

        const faviconSvg = document.querySelector('#faviconSvg');
        faviconSvg?.setAttribute('href', '/static/img/icons/favicon-napoleon-sport.svg');

        const safariPinnedTab = document.querySelector('#safariPinnedTab');
        safariPinnedTab?.setAttribute('href', '/static/img/icons/favicon-napoleon-sport.svg');

        const appleTouchIcon = document.querySelector('#appleTouchIcon');
        appleTouchIcon?.setAttribute('href', '/static/img/icons/apple-touch-icon-napoleon-sport.png');
    }

    if (window.location.hostname.includes('napoleonsports.be')) {
        const manifest = document.querySelector('#manifest');
        manifest?.setAttribute('href', '/static/manifest-napoleon-sport.json');
    }

    if (window.location.hostname.includes('napoleongames.be')) {
        const manifest = document.querySelector('#manifest');
        manifest?.setAttribute('href', '/static/manifest-napoleon-hub.json');
    }
}

export default adjustNapoleonFavicons;
